export default function($) {

  var apply_discount_trigger = $('#js-client-apply-discounts-trigger');

  // we do nothing if the selector is not found
  if (apply_discount_trigger.length) {

    $(apply_discount_trigger).click(function(event) {
      event.preventDefault()

      $('.iw-qty-updated').removeClass('iw-qty-updated')

      var variation_discount_input_fields = $('.js-client-input-discount-variation-field');
      var total_discount_input_field = $('#js-client-input-discount-total-field')
      var base_url = apply_discount_trigger.attr('href');

      var customer_id = apply_discount_trigger.data('customer-id');

      var discounts = {
        'lines_discount_data': {},
        'total_discount_percentage': total_discount_input_field.val(),
      }
      variation_discount_input_fields.each(function(index, element) {
        discounts['lines_discount_data'][$(element).data('order-line-id')] = $(element).val()
      });

      var data = {
        'discounts': discounts,
        'customer_id': customer_id,
      }

      //
      // @see https://codex.wordpress.org/AJAX_in_Plugins#Ajax_on_the_Viewer-Facing_Side
      //
      $.post(
        client_configuration.compute_discounts_url,
        data,
        function(response) {

          //
          // Get the response and format it
          //

          var formatted_reponse = $.parseJSON(response)
          var updated_product_discounts_to_update = $(formatted_reponse.updated_product_discounts)
          var updated_totals_to_update = formatted_reponse.updated_totals

          //
          // UI updates
          //

          // 1 - UI update concerning variation discounts :
          updated_product_discounts_to_update.each( function(index, element) {
            var product_variation_tr = $(element.product_variation_css_id)

            product_variation_tr.find('.product-unit-discounted-price')
                                .html(element.unit_price_with_discount)
                                .addClass('iw-qty-updated')
            product_variation_tr.find('.product-total')
                                .html(element.total_price)
                                .addClass('iw-qty-updated')
            product_variation_tr.find('.product-discount.js-client-input-discount-variation-field')
                                .html(element.discount_percentage)
                                .addClass('iw-qty-updated')
          } );

          // 2 - UI update concerning totals :

          // cart_subtotal_before_discount (false if no variation discounts)
          if (updated_totals_to_update.cart_subtotal_before_discount) {
            $('#js-cart-subtotal-before-discount').parent('tr')
                                                  .removeClass('sr-only')
            $('#js-cart-subtotal-before-discount').html(updated_totals_to_update.cart_subtotal_before_discount)
                                                  .addClass('iw-qty-updated')
          } else {
            $('#js-cart-subtotal-before-discount').parent('tr')
                                                  .addClass('sr-only')
          }

          // cart_products_discount_amount (false if no variation discounts)
          if (updated_totals_to_update.cart_products_discount_amount) {
            $('#js-cart-products-discount-amount').parent('tr')
                                                  .removeClass('sr-only')
            $('#js-cart-products-discount-amount').html(updated_totals_to_update.cart_products_discount_amount)
                                                  .addClass('iw-qty-updated')
          } else {
            $('#js-cart-products-discount-amount').parent('tr')
                                                  .addClass('sr-only')
          }

          // cart_subtotal_after_products_discount
          $('#js-cart-subtotal-after-products-discount').html(updated_totals_to_update.cart_subtotal_after_products_discount)
                                                        .addClass('iw-qty-updated')

          // cart_discount_percent_on_total
          $('#js-client-input-discount-total-field').val(updated_totals_to_update.cart_discount_percent_on_total)
                                                    .addClass('iw-qty-updated')

          // cart_discount_amount_on_total (false if no discount on total)
          if (updated_totals_to_update.cart_discount_amount_on_total) {
            $('#js-cart-discount-amount-on-total').parent('tr')
                                                  .removeClass('sr-only')
            $('#js-cart-discount-amount-on-total').html(updated_totals_to_update.cart_discount_amount_on_total)
                                                  .addClass('iw-qty-updated')
          } else {
            $('#js-cart-discount-amount-on-total').parent('tr')
                                                  .addClass('sr-only')
          }

          // cart_total
          $('#js-cart-total').html(updated_totals_to_update.cart_total)
                             .addClass('iw-qty-updated')

        }
      ).fail(function(response) {
        // Error, do nothing
      })

    });

  }

}
